import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class RegulationsStageTagsApi extends ApiModule {
	constructor() {
		super(ModulesMap.REGULATIONS_STAGE_TAGS, {
			entity: 'regulations_stage_tags',
			/* Ни popup, ни preview у сущности на бэкенде нет: оба метода ходят на обычный эндпоинт сущности. */
			useExtraSingleLoadingMethod: false,
		})
	}
}
